import { BubbleMenu as BubbleMenuTipTap } from '@tiptap/react';
import type { Editor } from '@tiptap/react';
import { RefObject, useState } from 'react';
import { BubbleMenuContent } from './BubbleMenuContent';
import { cn } from '@/Domain/utils/cn';

type Props = {
  editor: Editor;
  containerRef: RefObject<HTMLDivElement>;
  className?: string;
};

type SelectionMenuType = 'link' | null;

export const BubbleMenu = ({ editor, containerRef, className }: Props) => {
  const [selectionType, setSelectionType] = useState<SelectionMenuType | null>(null);

  if (!editor || !containerRef.current) return null;

  const handleLinkSubmit = (url: string) => {
    const formattedUrl = url.startsWith('http') ? url : `https://${url}`;
    editor
      .chain()
      .focus()
      .setLink({
        href: formattedUrl,
        target: '_blank',
      })
      .run();
    setSelectionType(null);
  };

  return (
    <BubbleMenuTipTap
      pluginKey="bubbleMenu"
      editor={editor}
      shouldShow={({ from, to }) => {
        const hasSelection = from !== to;

        if (!hasSelection) {
          setSelectionType(null);
        }

        return hasSelection;
      }}
      tippyOptions={{
        duration: 100,
        appendTo: containerRef.current,
        zIndex: 50,
        placement: 'top',
      }}
      className={cn(
        'flex items-center gap-1 rounded-md border border-border',
        'bg-card backdrop-blur-sm',
        'shadow-lg p-1 z-[50]',
        className,
      )}
    >
      <BubbleMenuContent
        editor={editor}
        selectionType={selectionType}
        setSelectionType={setSelectionType}
        onLinkSubmit={handleLinkSubmit}
      />
    </BubbleMenuTipTap>
  );
};
